import { parseVastMobileClientFromUserAgent } from './mobileUserAgent'

/**
 * Checks the window for the existence of `vastSessionObject`, or the URL for
 * the presence of a `jwtToken` query parameter.
 *
 * @returns {boolean} True if the user is using a mobile client, else false.
 */
export const isUsingMobileAuthentication = () => {
  return (
    !!window.vastSessionObject || window.location.href.includes('jwtToken=')
  )
}

/**
 * Checks the user-agent for known Vast mobile clients, or if mobile authentication
 * is being used.
 *
 * @returns {boolean} True if the user is using a mobile client, else false.
 */
export const isMobileAppClient = () => {
  // Attempt to parse the user agent for known Vast mobile clients
  const knownVastReachMobileClient = parseVastMobileClientFromUserAgent(
    navigator.userAgent,
  )

  // Is mobile client if is known, else check if the mobile client is using
  // a specific type of authentication.
  return !!knownVastReachMobileClient || isUsingMobileAuthentication()
}

export default isMobileAppClient
